module.exports = __webpack_public_path__ + "img/icon_getup_logo.b7b5878f.png";